export default "__VITE_ASSET__0MNR46ye__"